<template>

    <templatesite>

        <template v-slot:appheader>  <appheader></appheader>  </template>
        <template v-slot:appsidebar>  <appsidebar></appsidebar> </template>
        <template v-slot:appcontent>

            <div class="content">
                <div class="main-content">
                    <!-- Page Header -->
                    <div class="block justify-between page-header md:flex">
                        <div>
                            <h3 class="!text-defaulttextcolor dark:!text-defaulttextcolor/70 dark:text-white dark:hover:text-white text-[1.125rem] font-semibold">TABLEAU DE BORD</h3>
                        </div>
                        <div class="flex items-center">
                            <voyantsocket />
                        </div>
                    </div>
                    <!-- Page Header Close -->

                    <div class="grid grid-cols-12 gap-x-6">
                        <div class="xxl:col-span-12 xl:col-span-12 col-span-12">


                            <div class="grid grid-cols-12 gap-x-6">




                                <div class="xxl:col-span-12 xl:col-span-12 lg:col-span-12 md:col-span-12 sm:col-span-12 col-span-12">
                                    <div class="box hrm-main-card primary">
                                        <div class="box-body">
                                            <div class="flex items-start" v-bind:class="[nbredejours <30 ? 'col-md-6 alert alert-danger' : 'col-md-6']">

                                                <div class="flex-grow">
                                                    <span class="font-semibold text-[#8c9097] dark:text-white/50 block mb-1">Société : {{$store.state.etatraisonsocial}}</span>

                                                    <span class="font-semibold text-[#8c9097] dark:text-white/50 block mb-1">Expiration de la licence : {{$store.state.paramsystem.licence}}</span>
                                                    <h5 class="font-semibold mb-1 text-[1.25rem]">Il vous reste {{nbredejours}} jours avant l'expiration de votre licence.</h5>
                                                    <!--p class="mb-0">
                                                        <span class="badge bg-primary/10 text-primary">This Month</span>
                                                    </p-->
                                                </div>
                                                <!--div>
                                                    <span class="text-[0.875rem] font-semibold text-success">+1.03%</span>
                                                </div-->
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Présentation des modules Prévisions & Performance et Tableau de bord
                                     (jusqu'au 23/11/2026, selon les droits de l'utilisateur) -->
                                <div class="xxl:col-span-12 xl:col-span-12 lg:col-span-12 md:col-span-12 sm:col-span-12 col-span-12">
                                    <outilspilotage></outilspilotage>
                                </div>

                                <div v-if="nouveautesVisibles.length"
                                     class="xxl:col-span-12 xl:col-span-12 lg:col-span-12 md:col-span-12 sm:col-span-12 col-span-12">
                                    <div class="box">
                                        <div class="box-header nv-head">
                                            <div class="box-title nv-title">Nouveautés de l'application</div>
                                            <span v-if="nbNouveautesNonLues > 0" class="nv-cnt">
                                                {{ nbNouveautesNonLues }} non lue{{ nbNouveautesNonLues > 1 ? 's' : '' }}
                                            </span>
                                        </div>

                                        <div class="box-body !p-0">
                                            <template v-for="groupe in nouveautesVisibles" :key="'nvc' + groupe.categorie">
                                                <div class="nv-cat">{{ groupe.categorie }}</div>

                                                <!-- Le clic marque l'entrée comme lue : c'est le seul
                                                     déclencheur, il n'y a pas d'action globale. -->
                                                <div v-for="n in groupe.entrees" :key="'nv' + n.id"
                                                     class="nv-item" :class="{ 'nv-lu': estNouveauteLue(n.id) }"
                                                     @click="marquerNouveauteLue(n.id)">
                                                    <div class="nv-item-h">
                                                        <span class="nv-item-t">{{ n.titre }}</span>
                                                        <span v-if="!estNouveauteLue(n.id)" class="nv-badge">Nouveau</span>
                                                    </div>
                                                    <div class="nv-item-x">{{ n.miseajour }}</div>
                                                </div>
                                            </template>
                                        </div>
                                    </div>
                                </div>
                              


                                <div class="xl:col-span-12 col-span-12">
                                    <div class="box">
                                        <div class="box-header justify-between">
                                            <div class="box-title mb-2 sm:mb-0">
                                                Évolution de votre consommation de données sur HSIGCOM <span style="color: red">( {{totalmoconsomme}} Mo )</span>
                                            </div>
                                            <div class="inline-flex rounded-md shadow-sm" role="group" aria-label="Basic example">
                                                <button type="button" @click="loadevoluationdata('1M')" :class="indexbtnsuividata==='1M'?'ti-btn-primary-full text-white':'ti-btn-primary'" class="ti-btn-group !border-0 !text-xs !py-2 !px-3  ">1 Mois</button>
                                                <button type="button" @click="loadevoluationdata('2M')" :class="indexbtnsuividata==='2M'?'ti-btn-primary-full text-white':'ti-btn-primary'" class="ti-btn-group !border-0 !text-xs !py-2 !px-3  ">2 Mois</button>
                                                <button type="button" @click="loadevoluationdata('3M')" :class="indexbtnsuividata==='3M'?'ti-btn-primary-full text-white':'ti-btn-primary'" class="ti-btn-group !border-0 !text-xs !py-2 !px-3  !rounded-s-none">3 Mois</button>
                                            </div>
                                        </div>
                                        <div class="box-body">


                                            <apexcharts ref="mychart"  type="area" height="350"
                                                        :options="computedChartOptions"
                                                        :series="computedChartSeries"></apexcharts>



                                        </div>
                                    </div>
                                </div>







                            </div>
                        </div>

                    </div>
                    <div class="grid grid-cols-12 gap-x-6 col-span-12">

                    </div>

                </div>
            </div>



        </template>

    </templatesite>



</template>

<script>

    import templatesite from "@/components/template/apptemplate";
    import appheader from "@/components/template/appheader";
    import appsidebar from "@/components/template/appsidebar";
    import voyantsocket from "@/components/views/pages/voyantsocket";
    import outilspilotage from "@/components/views/accueil/outilspilotage";


    import {cloneobjet, currentMonth, currentYear, getnombredejours, getYear, randomString} from "@/allfunction";
    import * as JwtService from "@/common/jwt.service";
    const axios =require('axios');


    import VueApexCharts from "vue3-apexcharts";
    import {mapGetters} from 'vuex';

    /* ══════════════════════════════════════════════════════════════════════
       NOUVEAUTÉS DE L'APPLICATION
       ══════════════════════════════════════════════════════════════════════
       Le CONTENU vit désormais côté backend (controllers/nouveautesController.js),
       qui renvoie la liste déjà filtrée sur l'expiration et déjà triée. Publier
       une annonce ne demande donc qu'un redémarrage de l'API, sans reconstruire
       ni redéployer le front.

       Cette page ne fait plus que trois choses : demander la liste, la grouper
       par catégorie, et retenir ce que l'utilisateur a déjà lu. */
    const BASE_NOUVEAUTES = "/egl745874pnouveautes771714dfe";

    /* Mémoire des entrées déjà vues. La clé porte l'utilisateur : deux personnes
       qui se relaient sur le même poste ne se marquent pas les nouveautés lues
       l'une pour l'autre. */
    const CLE_NOUVEAUTES_LUES = "nouveautes_lues_v1";

    export default {
        /* eslint-disable */
        name: "index",
        components: {
            templatesite,
            appheader,
            appsidebar,
            voyantsocket,
            outilspilotage,

            apexcharts: VueApexCharts,

        },

        computed:{
            ...mapGetters(['totalmoconsomme','indexbtnsuividata','graphssuiviedata']),

            /* Nouveautés à afficher, groupées par catégorie.

               Le tri et le retrait des entrées périmées sont faits par le
               backend : on ne les refait pas ici, sinon la règle vivrait à deux
               endroits et finirait par diverger. L'ordre des catégories suit
               celui de la nouveauté la plus récente de chacune, donc le module
               qui vient de bouger remonte en tête. */
            nouveautesVisibles() {
                const groupes = [];
                for (const n of (Array.isArray(this.nouveautes) ? this.nouveautes : [])) {
                    if (!n || !n.id || !n.titre) continue;
                    const cat = n.categorie || "Général";
                    let g = groupes.find((x) => x.categorie === cat);
                    if (!g) { g = { categorie: cat, entrees: [] }; groupes.push(g); }
                    g.entrees.push(n);
                }
                return groupes;
            },

            nbNouveautesNonLues() {
                let n = 0;
                for (const g of this.nouveautesVisibles) {
                    for (const e of g.entrees) if (!this.estNouveauteLue(e.id)) n++;
                }
                return n;
            },

            filtercalendar(){
                let mvalue=this.datafiltercalendar;

                if (this.searchwordcalendar!==''){

                    // ref
                    let t=this
                    //mvalue = this.datatablesearch.filter( post => post.magasin.toLowerCase().includes(this.searchword))
                    mvalue = mvalue.filter( function (post) {
                        //return    post.name.toLowerCase().includes(t.searchwordcalendar.toLowerCase())
                        return    post.service.toLowerCase().includes(t.searchwordcalendar.toLowerCase())
                    })
                    //return this.postList.filter( post => post.intitule.toLowerCase().includes(this.searchword))
                }

                return mvalue ;
            },



            // Computed property for chart options
            computedChartOptions() {

                if (Object.keys(this.graphssuiviedata).length>0){

                    return  cloneobjet(this.graphssuiviedata.chartOptions);
                }
                else{
                    return  {};

                }



            },
            // Computed property for chart series data
            computedChartSeries() {
                // Simuler une modification des données

                if (Object.keys(this.graphssuiviedata).length>0){

                    return  cloneobjet(this.graphssuiviedata.series);
                }else{
                    return  [];

                }


            }

        },

        watch: {
            computedChartOptions(newOptions) {
                      this.updateChartOptions(newOptions);
                      // this.updateChart();
            },
            computedChartSeries(newSeries) {
                this.updateChartSeries(newSeries);
                //this.updateChart();
            }
        },

        data() {
            return {

                /* Liste renvoyée par le backend, demandée au montage. Vide tant
                   qu'elle n'est pas arrivée, et vide en cas de panne : la carte
                   reste alors simplement masquée. */
                nouveautes: [],

                /* Identifiants des nouveautés déjà consultées par CET utilisateur,
                   relus du localStorage au montage. */
                nouveautesLues: [],

                datatutoriel:[],
                nbredejours:getnombredejours(this.$store.state.paramsystem.licence,this.$store.state.appserverdate),

                imgurlrdv:'/icon/rdv.svg',
                imgurlpatient:'/icon/patient.svg',
                imgurlstaff:'/icon/staffs.svg',
                imgurllit:'/icon/lit.svg',


                datatablefindecontratpermannent:[],

                countp:0,
                allchurch:[],
                datamessageerror:[],
                messagesuccess:"",
                btnnextmonth:{mm:currentMonth(),manne:currentYear()},
                btnprevmonth:{mm:currentMonth(),manne:currentYear()},


                searchwordcalendar:'',
                searchtransaction:'',
                searchwordconge:'',
                searchwordabsence:'',
                nbrepersonnel:0,
                nbreoccasionnel:0,
                nbretotalemploye:0,
                nbrepermanentdebauche:0,
                nbreoccasionneldebaucher:0,
                listemassesalarialpermanent:[],

                mgetyear:getYear(),
                mmois:"",
                manne:"",
                dataPointObjects: [],
                datatodolist: [],
                datasuiviconge: [],
                datademandedecongenontraite: [],
                datademandedeabsencenontraite: [],
                datacalendar: {},
                datafiltercalendar: [],
                dataPointObjectsoccas: [],
                chartWidth: 600,
                chartHeight: 200,
               // url:this.$store.state.baseurl+'api/api_hpaie_v1.0.3.EXE',



                posts : [''],
                page: 1,
                perPage: 2,
                Defaultpage: 1,
                DefaultperPage: 2,
                pages: [],


                mposts : [''],
                mpage: 1,
                mperPage: 2,
                mDefaultpage: 1,
                mDefaultperPage: 2,
                mpages: [],





            };
        },
        methods: {

            /* ---------- Nouveautes ---------- */

            /* Demande la liste au backend. Silencieux par construction : une
               panne réseau ou une erreur serveur laisse `nouveautes` vide, donc
               la carte masquée. Une section d'information ne doit jamais faire
               échouer l'affichage de l'accueil, ni afficher un message d'erreur
               pour une annonce que l'utilisateur n'attendait pas. */
            async chargerNouveautes() {
                try {
                    const url = process.env.VUE_APP_API_URL + BASE_NOUVEAUTES
                        + "/app/othetdskd8755dsdhisd/liste/" + randomString(120);

                    const { data } = await axios.post(url, {}, {
                        headers: {
                            "X-Requested-With": "XMLHttpRequest",
                            Accept: "application/json",
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + JwtService.getToken(),
                            csrftoken: this.$store.state.appsociete,
                        },
                        withCredentials: true,
                    });

                    if (data && data.success && data.m && Array.isArray(data.m.nouveautes)) {
                        this.nouveautes = data.m.nouveautes;
                    }
                } catch (e) {
                    console.warn("[nouveautes] liste indisponible", e && (e.message || e));
                }
            },

            /* Cle de stockage propre a l'utilisateur connecte. Repli sur une cle
               commune si l'identite n'est pas encore chargee : mieux vaut un
               marquage partage qu'un plantage sur l'accueil. */
            _cleNouveautes() {
                let qui = "";
                try { qui = String(this.$store.state.appusername || JwtService.getTokenID() || ""); }
                catch (e) { qui = ""; }
                return CLE_NOUVEAUTES_LUES + (qui ? "_" + qui : "");
            },

            chargerNouveautesLues() {
                try {
                    const brut = localStorage.getItem(this._cleNouveautes());
                    const lu = brut ? JSON.parse(brut) : [];
                    this.nouveautesLues = Array.isArray(lu) ? lu : [];
                } catch (e) {
                    /* Mode prive, quota plein, valeur corrompue : on repart d'une
                       liste vide. Tout paraitra neuf, ce n'est pas grave. */
                    this.nouveautesLues = [];
                }
            },

            estNouveauteLue(id) {
                return this.nouveautesLues.indexOf(id) !== -1;
            },

            /* Le clic sur une entree est le SEUL declencheur du passage en lu.
               Idempotent : recliquer ne change rien. */
            marquerNouveauteLue(id) {
                if (!id || this.estNouveauteLue(id)) return;
                this.nouveautesLues.push(id);
                try {
                    localStorage.setItem(this._cleNouveautes(), JSON.stringify(this.nouveautesLues));
                } catch (e) { /* stockage indisponible : l'affichage reste correct pour la session */ }
            },


            updateChartOptions(newOptions) {

                // Mettre à jour les options du graphique
                //this.$refs.mychart.updateOptions(newOptions);

                if (this.$refs.mychart) {
                    this.$refs.mychart.updateOptions(this.computedChartOptions);

                }


            },
            updateChartSeries(newSeries) {

                // Mettre à jour les séries de données du graphique
              //  this.$refs.mychart.updateSeries(newSeries);

                if (this.$refs.mychart) {
                    this.$refs.mychart.updateSeries(this.computedChartSeries);

                }



            },


            async loadevoluationdata(value) {

                this.$store.dispatch('indexbtnsuividata',value)
                this.$store.dispatch('loadevoluationdata')
/*
                const t = this;
                let url=process.env.VUE_APP_API_URL+'/egl745874tb771714dfe/dash/graph/suividata/'+this.indexbtnsuividata+'/'+this.$store.state.appsociete+'/'+randomString();
                let response =   axios  .get(url,{
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Accept':'application/json',
                        'Content-Type':'application/json',
                        'Access-Control-Allow-Origin': '*',
                        'Access-Control-Allow-Methods': 'OPTIONS,GET,PUT,POST,DELETE',
                        'Access-Control-Allow-Headers': 'Content-Type',
                        'Authorization': 'Bearer ' + JwtService.getToken(),
                        'csrftoken': this.$store.state.appsociete
                    }
                })

                await response
                    .then(response => {

                        if (response.data.success){

                            t.graphssuivieca=response.data.allgraphs
                            t.totalmoconsomme=response.data.ttmo


                        }
                        else{


                            t.graphssuivieca={}

                        }


                    })
                    .catch(

                        error => toastr['error']( "Une erreur est subvenue. <br/> veuillez actualiser la page.",
                            "<b></b>")
                    )
                    .finally(() =>  this.$store.dispatch('lancerchargement',false))
*/
            },



            btnpreviousplanning(){

                this.loadplanning(this.btnprevmonth.mm,this.btnprevmonth.manne);

            },
            btnnextplanning(){


                this.loadplanning(this.btnnextmonth.mm,this.btnnextmonth.manne);


            },

            async loaddata(){

                const t = this;

                //let response =   axios  .get(process.env.VUE_APP_API_URL+'/egl745874dsfd5771714dfe/'+allfunction.randomString())
                let response =   axios  .get(process.env.VUE_APP_API_URL+'/')
                let res= await response
                    .then(function (res){

                        //console.log("res  ********* ",res)

                       /* if(res.data.res){
                            t.allchurch=res.data.m;
                        }else{
                            t.allchurch=[];
                        }

                        */


                    })
                    .catch((error)=>{
                            this.allchurch=[];


                        }
                    )
                    .finally(() =>{




                    })



            },

            async loaddatacountpersonnel(){


                const t = this;
                let url=process.env.VUE_APP_API_URL+'/egl745874tb771714dfe/countpers/'+this.$store.state.appsociete+'/'+randomString();
                let response = axios.get(url,{
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + JwtService.getToken(),
                        'csrftoken': this.$store.state.appsociete
                    } ,withCredentials: true // Permet l'envoi de cookies et autres informations d'authentification
                })
                let res= await response
                    .then(function (res){


                        t.nbrepersonnel=res.data.m.allpermanents
                        t.nbreoccasionnel=res.data.m.alloccasionnels
                        t.nbretotalemploye=res.data.m.allemploye
                        t.nbrepermanentdebauche=res.data.m.alldebaucherpermanents
                        t.nbreoccasionneldebaucher=res.data.m.alldebaucheroccasionnels



                    })
                    .catch((error)=>{


                        }
                    )
                    .finally(() =>{




                    })



            },

            async loadplanning($month,$year){



                const t = this;
                let url=process.env.VUE_APP_API_URL+'/egl745874tb771714dfe/planning/'+this.$store.state.appsociete+'/'+$month+'/'+$year+'/'+randomString();
                let response = axios.get(url,{
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + JwtService.getToken(),
                        'csrftoken': this.$store.state.appsociete
                    } ,withCredentials: true // Permet l'envoi de cookies et autres informations d'authentification
                })
                let res= await response
                    .then(function (res){

                        if(res.data[0].success){

                            t.datacalendar=res.data[0];

                            t.btnnextmonth=t.datacalendar.next
                            t.btnprevmonth=t.datacalendar.prev

                            t.datafiltercalendar=res.data[0].infoper

                        }
                        else{


                            t.datacalendar={}
                            t.datafiltercalendar=[]

                            t.btnnextmonth={mm:currentMonth(),manne:currentYear()}
                            t.btnprevmonth={mm:currentMonth(),manne:currentYear()}

                        }



                    })
                    .catch((error)=>{


                        }
                    )
                    .finally(() =>{




                    })



            },



            async loadfincontratdans6mois(){



                const t = this;
                let url=process.env.VUE_APP_API_URL+'/egl745874pdefinition771714dfe/tiers/personnel/'+this.$store.state.appsociete+'/findecontrat/personnel/'+randomString();
                let response =   axios  .get(url,{
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + JwtService.getToken(),
                        'csrftoken': this.$store.state.appsociete
                    } ,withCredentials: true // Permet l'envoi de cookies et autres informations d'authentification
                })

                let res= await response
                    .then(function (res){

                        t.datatablefindecontratpermannent=[];


                        if(res.data.success){

                            t.datatablefindecontratpermannent=res.data.m;

                        }
                        else{
                            t.datatablefindecontratpermannent=[];

                        }


                    })
                    .catch((error)=>{


                        }
                    )
                    .finally(() =>{




                    })


            },




        },
        mounted() {

            this.chargerNouveautesLues();
            this.chargerNouveautes();

            //this.loadfincontratdans6mois();
            //this.loaddatacountpersonnel();
            //this.loadplanning(currentMonth(),currentYear());


            // Initialisation du graphique avec les données et options initiales

            //this.updateChartOptions(this.computedChartOptions);
            //this.updateChartSeries(this.computedChartSeries);

            /* Le temps réel de cette page est porté par <voyantsocket>, qui ouvre
               sa propre liaison sur le namespace /presence (authentifié). L'ancienne
               tentative visait le canal par défaut, qui n'authentifie personne : elle
               a été retirée d'ici pour ne pas laisser croire à une alternative. */

        }






    }
</script>

<style scoped>

    /*********************  NOUVEAUTES  ********************/
    /* Volontairement typographique : aucune icone, aucun aplat de couleur en
       dehors du badge. C'est lui la seule zone saturee de la carte, donc le seul
       point ou l'oeil se pose en premier. */

    .nv-head { display: flex; align-items: baseline; gap: 12px; }
    .nv-title { font-weight: 650; letter-spacing: -.1px; }
    .nv-cnt { font-size: 12px; color: #8c9097; }

    .nv-cat {
        font-size: 10.5px; font-weight: 700; text-transform: uppercase; letter-spacing: .11em;
        color: #98a2b3; padding: 18px 20px 8px;
    }
    .nv-cat:first-child { padding-top: 14px; }

    .nv-item { padding: 13px 20px; border-top: 1px solid #eef1f5; cursor: pointer; }
    .nv-item:hover { background: #fbfcfd; }
    .nv-item-h { display: flex; align-items: baseline; gap: 10px; }
    .nv-item-t { font-weight: 650; font-size: 14px; letter-spacing: -.1px; }
    /* 74 caracteres par ligne : au-dela, l'oeil perd le debut de la ligne suivante. */
    .nv-item-x { font-size: 13px; color: #5b6675; margin-top: 3px; max-width: 74ch; }

    .nv-badge {
        margin-left: auto; font-size: 9.5px; font-weight: 800; letter-spacing: .09em;
        text-transform: uppercase; color: #fff;
        /* background: #1e3a8a;*/
         background: red;
        padding: 2px 7px; border-radius: 3px; position: relative; top: -1px; white-space: nowrap;
    }

    /* Lue : l'entree reste en place et lisible, elle cesse seulement de reclamer
       l'attention. */
    .nv-item.nv-lu .nv-item-t { font-weight: 600; color: #5b6675; }
    .nv-item.nv-lu .nv-item-x { color: #98a2b3; }

    @media (max-width: 640px) {
        .nv-item-h { flex-wrap: wrap; }
        .nv-badge { margin-left: 0; }
    }

    /* Mode sombre : le fond des cartes change, les gris doivent suivre. */
    html.dark .nv-cnt, html.dark .nv-cat { color: #8c9097; }
    html.dark .nv-item { border-top-color: rgba(255,255,255,.08); }
    html.dark .nv-item:hover { background: rgba(255,255,255,.03); }
    html.dark .nv-item-t { color: #e5e7eb; }
    html.dark .nv-item-x { color: #9ca3af; }
    html.dark .nv-item.nv-lu .nv-item-t { color: #9ca3af; }
    html.dark .nv-item.nv-lu .nv-item-x { color: #6b7280; }
    /*html.dark .nv-badge { background: #2563eb; }*/
    html.dark .nv-badge { background: red; }

    /*********************  CALENDA  ********************/

    .calendar-team tbody tr td.service {
        background: #f7f7f7;
        color: #858585;
        border-top-color: #d0d0d0;
        border-right-color: #d0d0d0;
        border-left-color: #d0d0d0;
        padding-top: 1.5rem;
        font-size: 1.00625rem;
    }

    .out {
        display: block;
        width: 100%;
        height: 100%;
        padding-top: 4px;
        background: #eae9e9 !important;
        color: #ccc;
    }

    .calendar-team thead tr th.header-day {
        width: 30px;
        min-width: 30px;
        max-width: 30px;
        font-size: 12px;
        background: #f7f7f7;
        font-weight: normal;
        padding: 1px 5px;
        text-align: center;
        border: 1px solid #adadad;
    }
    .cell-block {
        width: 30px;
        height: 30px;
        overflow: hidden;
    }


    .calendar-team thead tr th.header-month {
        overflow: hidden;
        border: 1px solid #adadad;
    }
    .calendar-team>table>thead>tr {
        width: 30px;
        min-width: 30px;
        max-width: 30px;
    }
    .calendar-team>table {
        padding: 0rem !important;
    }

    .calendar-team .table-sm th, .table-sm td {
        padding: 0rem;
        /*font-size: 12px!important;*/
        font-size: 11px;
    }

    .calendar-planningok{
        background-color: #00B666;
    }

    .calendar-planningnonlegal{
        background-color: tomato;
    }


    .calendar-planninglegal{
        background-color: darkorange;
    }





    .calendar-planningnok{
        background-color: #ffffff;
    }


    .calendar-planningnweekend{
       /* background-color: pink;*/
        background-color: #d9edf7;

    }

    .todayBorder {
        border-left: #a3cbdf 2px solid !important;
        border-left-color: #a3cbdf !important;
        border-right: #a3cbdf 2px solid !important;
        border-right-color: #a3cbdf !important;
        background-color: red!important;
    }

    .calendar-div{
        height: 350px;
        overflow: auto;
    }


    .header-month{
        font-size: 16px!important;
        text-align: center;
        font-weight: bold;

    }


</style>